<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Log de saldo por funcionario'" :showBtn="false" :btnName="''" :btnRoute="''"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                      <label>ID do funcionário</label>
                      <input type="text" v-model="dataSearch.userId" class="form-control" id="userId" name="userId">
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                      <label>Nome do funcionário</label>
                      <input type="text" v-model="dataSearch.name" class="form-control" id="name" name="name">
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                      <label>E-mail</label>
                      <input type="text" v-model="dataSearch.email" class="form-control" name="email" id="email">
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-4">
                    <div class="form-group">
                      <label>CPF</label>
                      <input type="text" v-model="dataSearch.cpf" class="form-control" id="cpf" name="cpf"
                             v-mask="['###.###.###-##']">
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Banco</label>
                      <input v-model="dataSearch.header" type="text" class="form-control" name="userId"
                             placeholder="UserID" required>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <button v-on:click="searchUser()">Pesquisar</button>
                </div>
              </div>
            </div>

            <!-- No Result -->
            <div v-if="!loadingList && (dataUser !== '' && !dataUser.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Sem resultado na pesquisa.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loadingList && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loadingList && dataUser.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total ({{ dataUser.length }})</span>

                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> EMPRESA</th>
                        <th> NOME</th>
                        <th> EMAIL</th>
                        <th> CONTRATADO EM</th>
                        <th> ÚLTIMO LOGIN</th>
                        <th> AÇÃO</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="a in dataUser">
                        <td>{{ a.companyName }}</td>
                        <td>{{ a.name }}</td>
                        <td>{{ a.email }}</td>
                        <td>{{ a.createdAt || formatDate }}</td>
                        <td>{{ a.lastLogin }}</td>
                        <td class="no-wrap">
                          <a v-bind:href="'/log-de-saldo/' + a.userId + '/' + a.contentSetting" title="Visualizar"
                             class="btn-to-view">
                            <i class="fa fa-eye" aria-hidden="true"></i> Visualizar
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import swal from 'sweetalert';

import {
  USERS
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";

export default {
  name: "log-de-saldo-por-funcionario",
  components: {
    topMenu,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      loadingList: false,
      failRequest: false,
      dataUser: '',
      dataSearch: {
        header: 'AAAA',
        userId: '',
        name: '',
        email: '',
        company: '',
        cpf: ''
      }
    }
  },
  methods: {
    changeUserCompany(user) {
      swal({
        title: "Aviso",
        text: "Você tem certeza que deseja alterar o usuário de empresa ? \n\n\n Informe o ID da nova empresa, sem o ID não é possível realizar essa operação.",
        icon: "warning",
        buttons: true,
        dangerMode: true,
        content: "input",
      })
        .then((valueInput) => {
          if (valueInput) {
            if (user.userId && user.contentSetting && valueInput) {

              let url = CHANGE_USER_FROM_COMPANY + "?userID=" + user.userId + "&companyId=" + valueInput;
              REQUEST_SERVICE.requestContext('GET', url, user.contentSetting).then((response) => {
                UTIL_SERVICE.console("RESULT CHANGE_USER_FROM_COMPANY:", response.data);

                ALERT_SERVICE.swal("Aviso", response.data, "success");
                this.searchUser();
              }).catch((reason) => {

                ALERT_SERVICE.showMsgError(reason.response.data.erros);
              });
            }
          }
        });
    },
    searchUser() {
      this.loadingList = true;

      let url = USERS + "?t=kkkk";
      if (this.dataSearch.name)
        url += "&name=" + this.dataSearch.name;

      if (this.dataSearch.email)
        url += "&email=" + this.dataSearch.email;

      if (this.dataSearch.cpf)
        url += "&cpf=" + this.dataSearch.cpf;

      if (this.dataSearch.userId)
        url += "&id=" + this.dataSearch.userId;

      if (this.dataSearch.header)
        url += "&contentSetting=" + this.dataSearch.header;

      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.requestContext('GET', url, this.dataSearch.header).then((response) => {
        UTIL_SERVICE.console("RESULT SEARCH USER:", response.data);

        this.dataUser = response.data.itens;
        this.loadingList = false;
        this.failRequest = false;
      }).catch((reason) => {
        this.loadingList = false;
        this.failRequest = true;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    }
  },
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/logPoint/logBalance.vue